import React from 'react';

const PhoneComponents = function PhoneComponents() {
  return (
    <div
      style={{
        display: 'flex',
        gap: '16px',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '15%',
      }}
    >
      <div
        style={{
          borderRadius: 50,
          backgroundColor: '#d9d9d9',
          width: '20px',
          height: '20px',
        }}
      />
      <div
        style={{
          borderRadius: 50,
          backgroundColor: '#d9d9d9',
          width: '150px',
          height: '10px',
        }}
      />
    </div>
  );
};

export default PhoneComponents;
